import React from 'react';
import { createRoot } from 'react-dom/client';

import './style/normalize.css';
import './style/style.scss';

import { Provider } from 'react-redux';
import store from './store';

import App from './App';

import { fetchTransferTypes } from './features/transferTypes/transferTypesSlice';
import { fetchPaymentMethods } from './features/paymentMethods/paymentMethodsSlice';

store.dispatch(fetchTransferTypes());
store.dispatch(fetchPaymentMethods());

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
